module.exports = __webpack_public_path__ + "9d2d10e53875b393b1acb0052b90cf08.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/mummy-head.png
// module id = 2315
// module chunks = 0